import React, { useEffect, useState } from 'react';
import { fetchQuizStatus } from '../api.js';

function WelcomePage({ onNext, onSession }) {
  const [schedule, setSchedule] = useState(null);
  const [notice, setNotice] = useState('');

  useEffect(() => {
    window.scrollTo(0, 0);
    let mounted = true;
    const refreshSchedule = () => fetchQuizStatus()
      .then((status) => mounted && setSchedule(status))
      .catch(() => mounted && setNotice('Quiz schedule is temporarily unavailable. Please try again shortly.'));

    refreshSchedule();
    const interval = window.setInterval(refreshSchedule, 30_000);
    window.addEventListener('focus', refreshSchedule);
    return () => {
      mounted = false;
      window.clearInterval(interval);
      window.removeEventListener('focus', refreshSchedule);
    };
  }, []);

  function startSession(sessionType) {
    const session = sessionType === 'official' ? schedule?.official : schedule?.dryRun;
    if (!session?.isOpen) {
      const sessionName = sessionType === 'official' ? 'Online Quiz' : 'Dry Run';
      const tense = session?.phase === 'ended' ? 'was' : 'will be';
      setNotice(session ? `${sessionName} ${tense} available from ${session.startLabel} to ${session.endLabel}.` : 'Quiz schedule is loading. Please try again in a moment.');
      return;
    }
    if (sessionType === 'official' && !schedule.officialQuestionsReady) {
      setNotice('Online Quiz is not available yet. Please contact the organizers.');
      return;
    }
    onSession(sessionType);
  }

  function startRegistration() {
    if (schedule?.registrationOpen === false) {
      setNotice('Registration is closed.');
      return;
    }
    onNext();
  }

  return (
    <div className="welcome-overlay">
      <div className="welcome-card">
        <div className="welcome-header">
          <img src="/napcon_logo2.jpeg" alt="NAPCON 2026" className="napcon-logo" />
          <img src="/pg_quiz.jpeg" alt="PG Quiz 2026" className="welcome-feature-image" />
        </div>

        <h2 className="register-title">Team Registration Form</h2>
        <p className="eligibility">
          <strong>Eligibility Criteria:</strong> DM/MD/DNB/Diploma respiratory diseases <strong>(PG students)</strong>
        </p>
        <p className="team-note-main">Each team will be composed of two PGs from same institute</p>

        {/* <div className="note-box">
          <strong>Note:</strong><br />
          This registration form is intended for PG students in pulmonary medicine only.<br />
          <span className="restriction-highlight">SR/DM Pulmonary medicine candidates should not register here.</span>
        </div> */}

        <div className="rules-section" style={{ textAlign: 'left' }}>
          <h3 className="rules-title">Rules</h3>
          <ol className="rules-list">
            <li>Attempt the quiz as a team with your partner using the same device, (preferably a laptop).</li>
            <li>Ensure good internet connectivity. (Internet speed of 2 Mbps is preferred.)</li>
            <li>Log in using your team number and the registered mobile number of either participant.</li>
            <li>There are no negative marks.</li>
            <li>There will be 30 multiple choice questions. Each question will be with one correct and three incorrect options.</li>
            <li>In the case of a tie between two teams in terms of score, the time taken to complete the quiz will be considered as a tie breaker. The team utilising less time to complete the quiz will be given the advantage.</li>
            <li>Total quiz duration will be 15 minutes. The maximum time to attempt any question is 30 seconds. The question will automatically change after 30 seconds are over. Press next if you have finished attempting the question before 30 seconds.</li>
            <li>Each question carries one mark if answered correctly.<br />There is no negative marking for incorrect answer.</li>
            <li>Post registration you will receive the confirmation message and team number through Email.</li>
          </ol>
        </div>


        <div className="welcome-action-buttons">
          <button className="next-btn" onClick={startRegistration}>
            Proceed to Registration
          </button>
          <div className="welcome-action-row">
            <div className="welcome-action-column">
              <button className="next-btn dry-run-btn" type="button" onClick={() => startSession('dry-run')}>
                Dry Run
              </button>
              <p className="dry-run-note">
                (Link remains the same. You will receive an email and whatsapp notification on this number when it begins.)
              </p>
            </div>
            <div className="welcome-action-column">
              <button className="next-btn quiz-btn" type="button" onClick={() => startSession('official')}>
                Online Quiz
              </button>
              <p className="dry-run-note">
                (Link remains the same. An email and whatsapp notification will be sent to this number when live.)
              </p>
            </div>
          </div>
        </div>
        {notice && <button type="button" className="session-notice" onClick={() => setNotice('')}>{notice} <span>×</span></button>}
      </div>
    </div>
  );
}

export default WelcomePage;
